import api from '@/services/Api';

class Nominations {
  static create(awardId, payload) {
    return api.post(`/awards/awards/${awardId}/nominations`, payload);
  }

  static all(params = {}) {
    return api.get('/awards/nominations', { params });
  }

  static get(id) {
    return api.get(`/awards/nominations/${id}`);
  }

  static update(id, payload) {
    return api.put(`/awards/nominations/${id}`, payload);
  }

  static submit(nominationId, payload) {
    return api.post(`/awards/nominations/${nominationId}/submit`, payload);
  }

  static delete(id) {
    return api.delete(`/awards/nominations/${id}`);
  }

  static createReview(nominationId, payload) {
    return api.post(`/awards/nominations/${nominationId}/reviews`, payload);
  }
}

export default Nominations;
